module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_isObject.js
 ** module id = 353
 ** module chunks = 0
 **/